import React, { Component } from 'react'
import Styled from 'styled-components'
import { compose } from 'react-apollo'

import { getAttrs } from 'utils/index'

import ComponentRenderer from 'components/ComponentRenderer'
import PageLoader from 'components/PageLoader'

import { preview as previewQuery } from 'components/Preview/queries'

const Main = Styled.div`
  height: 100%;
  overflow: auto;
  background-color: #fff;
`

class Preview extends Component {
  render() {
    if (this.props.loading) {
      return <PageLoader />
    }

    const pageComponents = this.props.project.page.components.map(pageComponent => ({
      _id: pageComponent._id,
      component: pageComponent.component,
      attrs: getAttrs(pageComponent.attributes, { parseAttributes: true })
    }))


    return (
      <Main>
        {pageComponents.map(pageComponent => (
          <ComponentRenderer
            key={pageComponent._id}
            theme={this.props.project.theme}
            pageComponent={pageComponent}
          />
        ))}
      </Main>
    )
  }
}

export default compose(
  previewQuery
)(Preview)



// WEBPACK FOOTER //
// ./src/components/Preview/index.js